import {QuoteService} from "../../../../../domain/in/quote/quote-service";
import {Big} from "big.js";
import {bigToString, parseBig} from "../../../../../utils/math-utils";
import {EnumPricingItemType} from "../../../../../domain/in/quote/pricing-item/pricing-item-type";
import {getTotalAmountWithCurrency} from "../../../../../utils/string-utils";
import {DevicePricingItem} from "../../../../../domain/in/quote/pricing-item/device-pricing-item";

export class TotalBillingStockAcMapper {

    constructor() {
    }

    public getTotalBillingStock(service: QuoteService, currency: string, locale: string): string {
        switch (service.code) {
            case 'LS':
                let total = new Big(0);
                service.customGroups.forEach(cg => {
                    cg.pricingItems.forEach(prc => {
                        if (prc.pricingItemType == EnumPricingItemType.DEVICE) {
                            total = total.add(this.getInitialStockLS(prc).mul(parseBig((prc as DevicePricingItem).device.appliedPrice)));
                        }
                    });
                });
                return getTotalAmountWithCurrency(bigToString(total), currency, locale);
            default:
                return '';
        }
    }

    getInitialStockLS(pricingItem: DevicePricingItem): Big {
        const exchangeRuleValue = pricingItem.userInputs.exchangeRule?.value;
        if (!exchangeRuleValue || exchangeRuleValue === 'aucun') {
            return new Big(0);
        }
        return new Big(pricingItem.userInputs.quantity).div(new Big(eval(pricingItem.userInputs.exchangeRule.value))).round();
    }

}
